import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';

const api = new ApiCore();


const CSOPatient = (props: any) => {

    const [remindReady, setRemindReady]= useState<any>(false);

    useEffect(() => {
        return () => {
        }
    }, [])

    useEffect(() => {
    }, [])

    
    return (
        <div className={styles.CSO_patient_content}>
        </div>
    )
}

export default withRouter(CSOPatient);